import fifaveClient from '../services/fifthaveClient'

class Fetcher { 
    get(path = '', param, headers = {}) {
        if (param != {}) {
            return fifaveClient.get(path, {
                params: param,
                headers: {
                    ...headers,
                },
            });
        } else {
            return fifaveClient.get(path, {
                headers: {
                    ...headers,
                },
            });
        }
    }

    post(path = '', param) {
        return fifaveClient.post(path, param);
    }

    patch(path = '', param) {
        return fifaveClient.patch(path, param);
    }

    put(path = '', param) {
        return fifaveClient.put(path, param);
    }

    delete(path = '', param) {
        return fifaveClient.delete(path, param);
    }

    upload(path = '', param) {
        return fifaveClient.post(path, param, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}

const fetcher = new Fetcher();
export default fetcher;
